<article class="item">
  <div class="item__info"></div>
</article>

<article class="item">
  <div class="item__info"></div>
</article>

<article class="item">
  <div class="item__info"></div>
</article>

<article class="item">
  <div class="item__info"></div>
</article>

<article class="item">
  <div class="item__info"></div>
</article>

<article class="item">
  <div class="item__info"></div>
</article>
